import mainPortrait from '../assets/portraits/blue2.jpg';
import { welcome } from '../data/copy';

function Welcome() {
  return (
    <section className="product-section">
      <div className="product-image-container">
        <img src={mainPortrait} alt="Noir Portrait" className="product-main-image" />
      </div>
      <div className="product-details">
        <h1>{welcome.heading}</h1>
        {welcome.paragraphs.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </div>
    </section>
  );
}

export default Welcome;
